<template>
  <div>
    <div
      :class="{
        [$style.progressContainer]: isFailed || isCompleted,
        [$style.failed]: isFailed,
        [$style.completed]:isCompleted,
        [$style.other]: !isFailed && !isCompleted,
      }"
    >
      {{ reportProgress }}
    </div>
  </div>
</template>

<script>

import * as ReportConstants from 'Reports/constants/reportsConstants';

const { ReportStatusConsts, ReportStatusDisplayConsts } = ReportConstants;

export default {
  name: 'ReportProgress',

  props: {
    item: {
      type: [Object, String],
      required: true,
    },
  },

  data() {
    return {
      ReportStatusConsts,
    };
  },

  computed: {
    isCompleted() {
      let completed;
      if (this.isString) {
        completed = this.item === ReportStatusConsts.completed;
      } else {
        completed = this.item.status === ReportStatusConsts.completed;
      }
      return completed;
    },
    isFailed() {
      let failed;
      if (this.isString) {
        failed = this.item === ReportStatusConsts.failed;
      } else {
        failed = this.item.status === ReportStatusConsts.failed;
      }
      return failed;
    },
    isString() {
      return typeof this.item === 'string';
    },
    reportProgress() {
      return ReportStatusDisplayConsts[this.isString ? this.item : this.item.status];
    },
  },
};
</script>
<style scoped module>
@value (
  jcError300,
  jcSuccess300
) from '~css/brand-colors.css';

.failed {
  background: jcError300;
}

.other {
  font-style: italic;
}

.completed {
  background: jcSuccess300;
}

.progressContainer {
  border-radius: 3px;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  width: 75px;
}
</style>
